import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Grid from '@mui/material/Unstable_Grid2';
import { Notice } from '../models/Notice';
import React from 'react';
import Typography from '@mui/material/Typography';
import dayjs from 'dayjs';
import { isEmpty } from 'lodash';
import styles from '../styles/NotificationPanel.scss';

export function SentNotifications(props: { notifications: Notice[] }) {
  const notifications = props.notifications;
  return isEmpty(notifications) ? (
    <Typography variant="body1" align="center" style={{ marginTop: '8px' }}>
      You haven't sent any notifications.
    </Typography>
  ) : (
    <>
      {notifications?.map((notification) => (
        <Box m={2}>
          <Grid container>
            <Grid className={styles.notificationBody}>
              <Card>
                <CardHeader
                  title={notification.subject}
                  subheader={dayjs(notification.created).format(
                    'DD MMM YYYY HH:mm'
                  )}
                />
                <CardContent>{notification.body}</CardContent>
              </Card>
            </Grid>
          </Grid>
        </Box>
      ))}
    </>
  );
}
